import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

import { DriverFuelAssignment } from '../../types';

export const deleteDriverFuelAssignment = createReduxAsyncThunk(
  `${DRIVERS_STATE}/deleteDriverFuelAssignment`,
  async (fuelTaskId: DriverFuelAssignment['fuelTaskId']) => {
    const { data } = await driversAPI.deleteDriverFuelAssignment(fuelTaskId);
    return data;
  }
);
